export default "__VITE_ASSET__5bcf8293__"